var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFd2Img3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0839844 14.0833C0.0839844 6.30532 6.38931 0 14.1673 0C21.9453 0 28.2507 6.30532 28.2507 14.0833C28.2507 21.8613 21.9453 28.1667 14.1673 28.1667C6.38931 28.1667 0.0839844 21.8613 0.0839844 14.0833Z",
    fill: "#C49A6C"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_47_1457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.7084 14.0833L11.344 18.4477C10.9179 18.8739 10.2298 18.8739 9.80368 18.4477C9.70245 18.3466 9.62215 18.2265 9.56736 18.0944C9.51258 17.9622 9.48438 17.8206 9.48438 17.6775C9.48438 17.5345 9.51258 17.3928 9.56736 17.2606C9.62215 17.1285 9.70245 17.0084 9.80368 16.9073L14.168 12.543",
    stroke: "#FAF3EC",
    strokeWidth: 1.02691,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.0605 15.6234L19.2992 13.3848",
    stroke: "#FAF3EC",
    strokeWidth: 1.02691,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7422 13.929L18.1004 13.2872C17.7923 12.9791 17.6229 12.5683 17.6229 12.1319V11.6903L16.2263 10.2835C15.9611 10.0168 15.6459 9.80512 15.2988 9.66061C14.9516 9.5161 14.5793 9.44161 14.2033 9.44141H12.627L13.0993 9.86244C13.4349 10.1599 13.7035 10.5252 13.8876 10.934C14.0717 11.3429 14.167 11.7862 14.1673 12.2346V13.0356L15.1942 14.0625H16.4625L17.6229 15.0432",
    stroke: "#FAF3EC",
    strokeWidth: 1.02691,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_1457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12.3229,
    height: 12.3229,
    fill: "white",
    transform: "translate(8.00586 7.92188)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFd2Img3);
export default __webpack_public_path__ + "static/media/FD2img3.0e6d9d66bb83df2eba172e67a8ef63e5.svg";
export { ForwardRef as ReactComponent };